export const CONTACT_APP_ACTIONS = {
    SET_SELECTED_ITEMS: "set-selected-items",
    SET_CONTACTS_LIST_REFRESH: "set-contacts-list-refresh",
    SET_LABELS_LIST_REFRESH: "set-labels-list-refresh",
};
